import getData from './../api/index';

export const defaults = {
    searchVal: '',
    user: JSON.parse(localStorage.getItem('authData')),
    searchBarVisiblity: false,
};

export const typeDefs = `
  type LoginData{
    user: User
    error: JSON
    status: Boolean
    searchBarVisiblity: Boolean
  }

  type User{
    recordtypeid:String,
    sfid:String,
    id:String,
    assigned_cmdi__c: String,
    secondary_cmdi__c: String,
    user_type__c, String,
    ekyc_complete__c: String,
    reporting_to_ammd__c: String,
    role: String
    this_ekyc_popup_complete__c: String,
     teacher_level__c: String,
    isintroduction_complete__c: String,
    phone: String
    approve_agreement__c: String
  }

  type Mutation {
    search(val: String!): String
    login(phoneno:String! role:String!):LoginData
    logout:Boolean
    handlePhoneSubmit: 
    showSearch:Boolean
    hideSearch:Boolean
  }

  type Query {
    searchVal: String
    user: User
  }
`;
export const resolvers = {
    Mutation: {
        search: (_, variables, { cache }) => {
            const data = {
                searchVal: variables.val,
            };
            cache.writeData({ data });
            return variables.val;
        },
        logout: (_, variables, { cache }) => {
            localStorage.removeItem('authData');
            const data = {
                user: null,
            };
            cache.writeData({ data });
            return true;
        },
        login: async (_, variables, { cache }) => {
            const { role, phoneno } = variables;
            const {
                result: [userData],
            } =
                role === 'AMMD' || role === 'CMDI'
                    ? await getData(`SELECT Id, SFId, Reporting_To_AMMD__c 
          FROM Salesforce.Pidilite_User__c 
          WHERE Login_Mobile_Number__c = '${phoneno}' 
          AND type__c='${role}'`)
                    : await getData(`SELECT Id, SFId, this_ekyc_popup_complete__c, teacher_level__c,
          isintroduction_complete__c, phone,Allowed_Workshop__c,approve_agreement__c, 
          Assigned_CMDI__c,secondary_cmdi__c,user_type__c, ekyc_complete__c FROM Salesforce.Account 
          WHERE Phone = '${phoneno}' 
          AND RecordTypeId= '${process.env.REACT_APP_FCP_RECORD_TYPE_ID}'`);

            // const {
            //   result: [profileData]
            // } = await getData(
            //   `SELECT * FROM Salesforce.Account Where sfid = '${
            //   process.env.REACT_APP_FCP_ACCOUNT_ID
            //   }' `
            // );

            const data = {
                user: {
                    ...{
                        recordtypeid: null,
                        sfid: null,
                        id: null,
                        assigned_cmdi__c: null,
                        secondary_cmdi__c: null,
                        user_type__c: null,
                        ekyc_complete__c: null,
                        reporting_to_ammd__c: null,
                        role: null,
                        this_ekyc_popup_complete__c: null,
                        teacher_level__c: null,
                        isintroduction_complete__c: null,
                        phone: null,
                        approve_agreement__c: null,
                    },
                    ...userData,
                    role: variables.role,
                    status: 'loggedIn',
                    __typename: 'User',
                },
            };
            cache.writeData({ data });
            localStorage.setItem('authData', JSON.stringify(data.user));
            return {
                user: data.user,
                error: null,
                status: true,
                __typename: 'LoginData',
            };
        },

        showSearch: (_, variables, { cache }) => {
            const data = {
                searchBarVisiblity: true,
            };
            cache.writeData({ data });
            return true;
        },

        hideSearch: (_, variables, { cache }) => {
            const data = {
                searchBarVisiblity: false,
            };
            cache.writeData({ data });
            return false;
        },
    },
};
